import type { PropsWithChildren } from "react"

export type ThemeProviderProps = PropsWithChildren<{
  defaultTheme?: string
  storageKey?: string
}>

export function ThemeProvider({ children }: ThemeProviderProps) {
  return children
}